import React from 'react';
import loaderVideo from '../../assets/video/swipe-animation.mp4';

const LoaderTooltip: React.FC = () => {
  return (
    <div className="Loader">
      <div className="overlay-container">
        <div className="tooltip">
          <p>Swipe to explore</p>
          <video src={loaderVideo} autoPlay loop muted playsInline />
        </div>
      </div>
    </div>
  );
};

export default LoaderTooltip;
